<template>
  <div>
    <section class="banner banner_programa">
      <div class="overlay"></div>

      <div class="contenido">
        <div class="idiomas">
          <el-button type="default" class="idioma" @click="switchLocale('es')">ES</el-button>
          <el-button type="default" class="idioma" @click="switchLocale('en')">EN</el-button>
        </div>
        <el-row :gutter="20">
          <el-col :span="24" data-aos="fade-right" data-aos-offset="300"><div class="titulo_principal_css" v-html="$t('header.titulo_integridad')"></div></el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js'

export default {
  data() {
    return { index: null }
  },
  methods: {
    switchLocale(tipo) {
      // alert('hola')
      // if (this.$i18n.locale === 'es') {
      this.$i18n.locale = tipo
      // } else {
      // this.$i18n.locale = 'es'
      // }
      EventBus.$emit('change-lenguaje', this.$i18n.locale)
    },
  },
}
</script>
<style>
.banner_programa {
  position: relative;
  background-image: url('~@/assets/fotos/INTEGRIDAD.jpg') !important; /* ruta válida Vue 2 */
  background-size: cover;
  background-position: center;
  height: 250px;
  color: white;
  overflow: hidden;
  display: flex;
  align-items: center;
  /* padding: 0px 15%; */

  /* justify-content: center; */
}
@media (min-width: 2561px) {
  .titulo_principal_css {
    font-size: 65px;
  }
  .banner_programa {
    height: 280px;

    padding: 0px 10%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .titulo_principal_css {
    font-size: 62px;
  }
  .banner_programa {
    height: 270px;
    padding: 0px 10%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .titulo_principal_css {
    font-size: 56px;
  }
  .banner_programa {
    height: 300px;

    padding: 0px 10%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .titulo_principal_css {
    font-size: 50px;
  }
  .banner_programa {
    height: 300px;

    padding: 0px 11%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .titulo_principal_css {
    font-size: 51px;
  }
  .banner_programa {
    height: 450px;

    padding: 0px 3% 0px 10%; /* justify-content: center; */
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .titulo_principal_css {
    font-size: 40px;
  }
  .banner_programa {
    position: relative;
    background-size: cover;
    background-position: center;
    height: 380px;
    color: white;
    overflow: hidden;
    /* display: flex; */
    /* align-items: center; */
    /* padding: 0px 3% 0px 10%; */
  }
}
@media (max-width: 375px) {
  .titulo_principal_css {
    font-size: 40px;
  }
  .banner_programa {
    height: 400px;

    padding: 0px 3% 0px 10%;
    /* justify-content: center; */
  }
}
</style>
